export default __webpack_public_path__ + "static/media/Snd41.c6e0238d.mp3";